module.exports = __webpack_public_path__ + "img/write.df91740a.png";